ic-input-label {
  margin-bottom: var(--ic-space-xs);

  --ic-typography-color: var(
    --ic-input-label-text-color,
    var(--ic-color-text-primary)
  );
}

ic-input-label.with-helper {
  margin-bottom: 0;
}

ic-input-label.ic-input-label-readonly {
  --ic-typography-color: var(--ic-input-label-readonly-typography-color);
}

ic-input-label .helpertext,
ic-input-label .helpertext ::slotted(*) {
  margin-top: var(--ic-space-xxxs);
  padding-bottom: var(--ic-input-label-helpertext-padding, 0);

  --ic-typography-color: var(
    --ic-input-label-helper-text-color,
    var(--ic-color-text-secondary)
  );
}

ic-input-label .helpertext-normal {
  --ic-typography-color: var(
    --ic-input-label-helper-text-color,
    var(--ic-color-text-secondary)
  );
}

ic-input-label .helpertext-readonly {
  --ic-typography-color: var(--ic-input-label-readonly-helpertext-color);
}

ic-input-label .readonly-label {
  --ic-typography-color: var(--ic-input-label-readonly-label-color);
}

ic-input-label .error-label {
  --ic-typography-color: var(--ic-input-label-error-label-color);
}
